import { Fragment, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import HeadTitle from '@/components/ui/custom/HeadTitle';
import PageTitle from '@/components/ui/custom/PageTitle';
import Text from '@/components/ui/custom/dataDisplay/Text';
import CourseProgressView from '@/components/_deprecated/courses/progress/CourseProgressView';
import { useExtraCourseSelection } from '@/data/hook/useExtraCourseSelection';
import useStudentContext from '@/data/hook/useStudentContext';
import { Course } from '@/models/Course';
import { getErrorMessage } from '@/utils/getErrorMessage';
import LoadingView from '../LoadingView';

export default function StudentCoursesView() {
  const { t } = useTranslation('translation', {
    keyPrefix: 'coursesView.student',
  });
  const {
    progress,
    currentProgress,
    loadingDashboard,
    dashboardStatsError,
    otherCoursesStats,
    selectProgress,
  } = useStudentContext();

  useExtraCourseSelection({
    currentProgress,
    otherCoursesStats,
    selectProgress,
  });

  const [completedCourses, setCompletedCourses] = useState<Course[]>([]);

  useEffect(() => {
    let mounted = true;
    if (mounted && !completedCourses) {
      const completedProgresses: Course[] = [];
      progress?.forEach(({ progress, coursePath }) => {
        if (progress === 1) {
          completedProgresses.push(coursePath.course);
        }
      });
      setCompletedCourses(completedProgresses);
    }

    return () => {
      mounted = false;
    };
  }, [completedCourses, progress]);

  if (loadingDashboard) return <LoadingView />;

  if (dashboardStatsError)
    return (
      <Fragment>
        <HeadTitle routeInfo={t('courses')} />
        <Text
          text={getErrorMessage(dashboardStatsError)}
          format="rubik-500"
          className="text-primary"
        />
      </Fragment>
    );

  if (progress.length && currentProgress) {
    return (
      <main className="flex flex-col gap-2.5">
        <HeadTitle routeInfo={t('courses')} />

        <section className="flex flex-col justify-between">
          <PageTitle headingText={t('courses')} position="mb-3.5" />
        </section>

        <CourseProgressView />
      </main>
    );
  }

  return null;
}
